// custom typefaces
import 'typeface-oswald'
import 'typeface-pt-sans'

// syntax hihlighting
require('prism-themes/themes/prism-nord.css')
